import { Box, TextField, Button, Collapse } from '@mui/material';
import { styled, alpha } from '@mui/material/styles';

export const FilterContainer = styled(Box)(({ theme }) => ({
  padding: theme.spacing(2, 0),
  background: 'transparent',
  borderRadius: theme.spacing(2),
  boxShadow: 'none',
  border: 'none',
}));

export const FilterRow = styled(Box)(({ theme }) => ({
  display: 'flex',
  flexWrap: 'nowrap',
  paddingLeft: 0,
  paddingRight: 0,
  gap: theme.spacing(2),
  width: '100%',
  alignItems: 'center',
}));

export const SecondaryFilterRow = styled(Box)(({ theme }) => ({
  display: 'grid',
  paddingLeft: 0,
  paddingRight: 0,
  gridTemplateColumns: '1fr 1fr 1fr 1fr 1fr 1fr',
  gap: theme.spacing(2.5),
  width: '100%',
  alignItems: 'end',
  marginTop: theme.spacing(3),
  [theme.breakpoints.down('lg')]: {
    gridTemplateColumns: '1fr 1fr 1fr',
    gridTemplateRows: '1fr 1fr',
  },
  [theme.breakpoints.down('md')]: {
    gridTemplateColumns: '1fr',
    gridTemplateRows: 'repeat(6, 1fr)',
  },
}));

export const StyledTextField = styled(TextField)(({ theme }) => {
  const isDark = theme.palette.mode === 'dark';
  const bg = isDark
    ? alpha(theme.palette.common.white, 0.08)
    : alpha(theme.palette.common.white, 0.9);
  const bgHover = isDark
    ? alpha(theme.palette.common.white, 0.1)
    : alpha(theme.palette.common.white, 0.95);
  const bgFocus = isDark ? alpha(theme.palette.common.white, 0.12) : theme.palette.background.paper;
  return {
    '& .MuiOutlinedInput-root': {
      borderRadius: theme.spacing(1.5),
      backgroundColor: bg,
      backdropFilter: 'blur(10px)',
      transition: 'all 0.2s ease-in-out',
      '&:hover': {
        backgroundColor: bgHover,
        transform: 'translateY(-1px)',
        boxShadow: isDark ? '0 4px 12px rgba(0, 0, 0, 0.25)' : '0 4px 12px rgba(0, 0, 0, 0.1)',
      },
      '&.Mui-focused': {
        backgroundColor: bgFocus,
        transform: 'translateY(-1px)',
        boxShadow: isDark
          ? `0 4px 20px ${alpha(theme.palette.primary.main, 0.25)}`
          : '0 4px 20px rgba(59, 130, 246, 0.15)',
      },
    },
    '& .MuiInputLabel-root': {
      fontWeight: 500,
      color: theme.palette.text.secondary,
      '&.MuiInputLabel-shrink': {
        transform: 'translate(14px, -9px) scale(0.75)',
      },
    },
    '& .MuiOutlinedInput-notchedOutline': {
      '& legend': {
        maxWidth: 'none',
        width: 'fit-content',
        minWidth: 0,
        padding: '0 8px',
        boxSizing: 'content-box',
      },
    },
    '& .MuiInputBase-input': {
      color: theme.palette.text.primary,
    },
  };
});

export const ModernButton = styled(Button)(({ theme }) => ({
  borderRadius: theme.spacing(1.5),
  textTransform: 'none',
  fontWeight: 600,
  padding: theme.spacing(1, 2.5),
  transition: 'all 0.2s ease-in-out',
  '&:hover': {
    transform: 'translateY(-2px)',
    boxShadow: '0 8px 25px rgba(0, 0, 0, 0.15)',
  },
}));

export const FilterCollapse = styled(Collapse)({});
